(function() {
  angular
  .module('meanApp')
  .factory('featuresManager', featuresManager);

  featuresManager.$inject = ["Feature", "modelManager"];
  function featuresManager (Feature, modelManager) {
		return angular.extend({}, modelManager.init(Feature));
  };

})();